
function durationSort(a, b) {
    var a_start = a.education_duration_start,
        b_start = b.education_duration_start;
    return a_start.diff(b_start) * -1;
}


module.directive('educationFollowup', function($q,
                                               FollowupService,
                                               ModelService,
                                               Notifications) {
    return {
        restrict: 'E',
        templateUrl: 'students/followup/EducationFollowupDirective',
        scope: {
            placementId: '=',
            verificationAdded: '&',
        },
        link: function(scope, element, attrs) {
            scope.loading = true;
            loadData();

            scope.classes = function() {
                return {
                    issue: scope.followup && scope.followup.has_issue,
                    loaded: !scope.loading,
                    open: !!scope.data.action,
                    closed: !scope.data.action,
                    ended: !!(scope.followup && scope.followup.end_date),
                };
            };

            function setData(data) {
                scope.loading = false;
                scope.followup = data;
            }

            function loadData() {
                scope.data = {};
                FollowupService.loadFollowup('education_placement', scope.placementId)
                    .then(setData);
            }


            scope.save = function(form, data) {
                var success;
                if (!form.$valid) {
                    Notifications.canned('form_errors');
                    return $q.reject();
                }

                if (data.action === 'end') {
                    return ModelService.patch('education_placement_duration',
                                       scope.followup.last_duration, {
                        education_duration_end: data.date,
                        education_duration_reason: data.reason,
                    }).then(function() {
                        Notifications.success("Placement ended.")
                        loadData();
                    });
                }

                else {
                    success = data.action === 'verify';
                    return FollowupService.createPlacementFollowup(
                        scope.followup.participant_id,
                        {id: scope.placementId, $model_name: 'education_placement'},
                        success, data.date)

                        .then(function(verification) {
                            msg = success ? "Verified" : "marked as unable to verify.";
                            Notifications.success("Placement " + msg);
                            form.$setPristine();
                            loadData();
                            scope.verificationAdded({verification: verification})
                        });
                }

            }
        }
    }
});